<div class="min-h-screen py-8">
    <div class="max-w-7xl mx-auto px-4">
        <!-- Header -->
        <div class="mb-6">
            <div class="flex items-center text-sm text-gray-600 mb-2">
                <a routerLink="/console/parametros-sistema" class="hover:text-blue-600">
                    <i class="fas fa-arrow-left mr-2"></i>
                    Parámetros del Sistema
                </a>
            </div>
            <h1 class="text-3xl font-bold text-gray-900">Configuración de Aplicación Móvil</h1>
            <p class="text-gray-600 mt-1">Administra servicios disponibles y configuraciones de la aplicación móvil</p>
        </div>

        <!-- Tab Navigation -->
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
            <div class="border-b border-gray-200">
                <nav class="flex -mb-px">
                    <button (click)="changeTab('services')" [class.border-blue-500]="activeTab === 'services'"
                        [class.text-blue-600]="activeTab === 'services'"
                        [class.border-transparent]="activeTab !== 'services'"
                        [class.text-gray-500]="activeTab !== 'services'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-list mr-2"></i>
                        Servicios Disponibles
                    </button>
                    <button (click)="changeTab('simon')" [class.border-blue-500]="activeTab === 'simon'"
                        [class.text-blue-600]="activeTab === 'simon'" [class.border-transparent]="activeTab !== 'simon'"
                        [class.text-gray-500]="activeTab !== 'simon'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-comments mr-2"></i>
                        Configuración SIMON
                    </button>
                    <button (click)="changeTab('register')" [class.border-blue-500]="activeTab === 'register'"
                        [class.text-blue-600]="activeTab === 'register'"
                        [class.border-transparent]="activeTab !== 'register'"
                        [class.text-gray-500]="activeTab !== 'register'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-user-plus mr-2"></i>
                        Registro
                    </button>
                    <button (click)="changeTab('carrusel')" [class.border-blue-500]="activeTab === 'carrusel'"
                        [class.text-blue-600]="activeTab === 'carrusel'"
                        [class.border-transparent]="activeTab !== 'carrusel'"
                        [class.text-gray-500]="activeTab !== 'carrusel'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-images mr-2"></i>
                        Carrusel
                    </button>
                    <button (click)="changeTab('homeModal')" [class.border-blue-500]="activeTab === 'homeModal'"
                        [class.text-blue-600]="activeTab === 'homeModal'"
                        [class.border-transparent]="activeTab !== 'homeModal'"
                        [class.text-gray-500]="activeTab !== 'homeModal'"
                        class="flex-1 py-4 px-6 text-center border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors focus:outline-none">
                        <i class="fas fa-window-restore mr-2"></i>
                        Modal Home App
                    </button>
                </nav>
            </div>

            <!-- Tab Content -->
            <div class="p-6">
                <!-- Services Tab -->
                <div *ngIf="activeTab === 'services'">
                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-xl font-semibold text-gray-900">Servicios Disponibles en la App</h2>
                        <button data-rbac-permiso="config.app_movil.create" *ngIf="_auth.hasPermission('config.app_movil.create')" (click)="openAddServiceModal()"
                            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <i class="fas fa-plus mr-2"></i>
                            Agregar Servicio
                        </button>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="servicesLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando servicios...</p>
                    </div>

                    <!-- Services List -->
                    <div *ngIf="!servicesLoading && rootServices.length > 0" class="space-y-3">
                        <div *ngFor="let service of rootServices" class="space-y-2">
                            <!-- Parent Service -->
                            <div
                                class="bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-blue-300 transition-colors">
                                <div class="flex items-center justify-between">
                                    <div class="flex-1">
                                        <h3 class="text-lg font-semibold text-gray-900">{{ service.name || service.code
                                            }}
                                        </h3>
                                        <p class="text-sm text-gray-600 mt-1" *ngIf="service.description">{{
                                            service.description }}</p>
                                        <p class="text-xs text-gray-500 mt-1">
                                            <span class="font-mono bg-gray-200 px-2 py-1 rounded">{{ service.code
                                                }}</span>
                                        </p>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <!-- Toggle Switch -->
                                        <label class="relative inline-flex items-center cursor-pointer">
                                            <input type="checkbox" [checked]="service.enabled"
                                                (change)="toggleService(service, $event)" [disabled]="service.loading || !_auth.hasPermission('config.app_movil.config')"
                                                class="sr-only peer" />
                                            <div
                                                class="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                                            </div>
                                            <span class="ml-3 text-sm font-medium text-gray-700">
                                                {{ service.enabled ? 'Activo' : 'Inactivo' }}
                                            </span>
                                        </label>

                                        <!-- Delete Button -->
                                        <button data-rbac-permiso="config.app_movil.delete" *ngIf="_auth.hasPermission('config.app_movil.delete')" (click)="deleteService(service)" [disabled]="service.deleting"
                                            class="text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                            title="Eliminar servicio">
                                            <i class="fas" [class.fa-spinner]="service.deleting"
                                                [class.fa-spin]="service.deleting"
                                                [class.fa-trash]="!service.deleting"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Child Services -->
                            <div *ngIf="service.children && service.children.length > 0"
                                class="ml-8 space-y-2 border-l-2 border-gray-200 pl-4">
                                <div *ngFor="let child of service.children"
                                    class="bg-white rounded-lg border border-gray-200 p-3 hover:border-blue-300 transition-colors">
                                    <div class="flex items-center justify-between">
                                        <div class="flex-1">
                                            <div class="flex items-center">
                                                <i class="fas fa-level-up-alt fa-rotate-90 text-gray-400 mr-2"></i>
                                                <h4 class="text-md font-medium text-gray-900">{{ child.name ||
                                                    child.code }}</h4>
                                            </div>
                                            <p class="text-xs text-gray-600 mt-1 ml-6" *ngIf="child.description">{{
                                                child.description }}</p>
                                            <p class="text-xs text-gray-500 mt-1 ml-6">
                                                <span class="font-mono bg-gray-100 px-2 py-0.5 rounded">{{ child.code
                                                    }}</span>
                                            </p>
                                        </div>
                                        <div class="flex items-center space-x-4">
                                            <!-- Toggle Switch -->
                                            <label class="relative inline-flex items-center cursor-pointer">
                                                <input type="checkbox" [checked]="child.enabled"
                                                    (change)="toggleService(child, $event)" [disabled]="child.loading || !_auth.hasPermission('config.app_movil.config')"
                                                    class="sr-only peer" />
                                                <div
                                                    class="w-9 h-5 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600">
                                                </div>
                                            </label>

                                            <!-- Delete Button -->
                                            <button data-rbac-permiso="config.app_movil.delete" *ngIf="_auth.hasPermission('config.app_movil.delete')" (click)="deleteService(child)" [disabled]="child.deleting"
                                                class="text-red-600 hover:text-red-800 hover:bg-red-50 p-1.5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                                title="Eliminar servicio">
                                                <i class="fas fa-sm" [class.fa-spinner]="child.deleting"
                                                    [class.fa-spin]="child.deleting"
                                                    [class.fa-trash]="!child.deleting"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="!servicesLoading && services.length === 0" class="text-center py-12">
                        <i class="fas fa-inbox text-6xl text-gray-300 mb-4"></i>
                        <p class="text-gray-600 text-lg mb-2">No hay servicios configurados</p>
                        <p class="text-gray-500 text-sm">Agrega un servicio para comenzar</p>
                    </div>
                </div>

                <!-- SIMON Tab -->
                <div *ngIf="activeTab === 'simon'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Configuración de SIMON Chat</h2>

                    <!-- Loading State -->
                    <div *ngIf="simonLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- SIMON Configuration -->
                    <div *ngIf="!simonLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-comments text-blue-600 mr-2"></i>
                                    Mostrar SIMON Chat en la App
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si el chat de SIMON está visible para los usuarios en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="showSimon" (change)="onSimonToggleChange($event)"
                                        [disabled]="simonToggleLoading || !_auth.hasPermission('config.app_movil.config')" class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="showSimon"
                                        [class.text-gray-500]="!showSimon">
                                        {{ showSimon ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <!-- Status Indicator -->
                        <div class="mt-4 pt-4 border-t border-gray-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0">
                                    <div class="h-3 w-3 rounded-full" [class.bg-green-500]="showSimon"
                                        [class.bg-gray-400]="!showSimon"></div>
                                </div>
                                <p class="ml-3 text-sm text-gray-600">
                                    Estado actual:
                                    <span class="font-semibold" [class.text-green-600]="showSimon"
                                        [class.text-gray-600]="!showSimon">
                                        {{ showSimon ? 'Los usuarios pueden ver el chat de SIMON' : 'El chat de SIMON
                                        está oculto' }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Register Tab -->
                <div *ngIf="activeTab === 'register'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Control de Registro de Usuarios</h2>

                    <!-- Loading State -->
                    <div *ngIf="registerLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- Register Configuration -->
                    <div *ngIf="!registerLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-user-plus text-blue-600 mr-2"></i>
                                    Habilitar Registro de Nuevos Usuarios
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si los nuevos usuarios pueden registrarse en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="registerEnabled"
                                        (change)="onRegisterToggleChange($event)" [disabled]="registerToggleLoading"
                                        class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="registerEnabled"
                                        [class.text-gray-500]="!registerEnabled">
                                        {{ registerEnabled ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>

                        <!-- Status Indicator -->
                        <div class="mt-4 pt-4 border-t border-gray-200">
                            <div class="flex items-center">
                                <div class="flex-shrink-0">
                                    <div class="h-3 w-3 rounded-full" [class.bg-green-500]="registerEnabled"
                                        [class.bg-gray-400]="!registerEnabled"></div>
                                </div>
                                <p class="ml-3 text-sm text-gray-600">
                                    Estado actual:
                                    <span class="font-semibold" [class.text-green-600]="registerEnabled"
                                        [class.text-gray-600]="!registerEnabled">
                                        {{ registerEnabled ? 'Los usuarios pueden registrarse en la app' : 'El registro
                                        de usuarios está deshabilitado' }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Message Editor Section -->
                    <div *ngIf="!registerLoading" class="bg-white rounded-lg border border-gray-200 p-6 mt-6">
                        <div class="mb-4">
                            <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                <i class="fas fa-comment-alt text-blue-600 mr-2"></i>
                                Mensaje de Registro Deshabilitado
                            </h3>
                            <div class="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <i class="fas fa-exclamation-triangle text-yellow-400"></i>
                                    </div>
                                    <div class="ml-3">
                                        <p class="text-sm text-yellow-700">
                                            Este mensaje se mostrará a los usuarios cuando intenten registrarse y el
                                            registro esté deshabilitado.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-2">
                                    Mensaje
                                </label>
                                <textarea [(ngModel)]="registerMessage" rows="4"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Ingrese el mensaje que verán los usuarios cuando el registro esté deshabilitado"></textarea>
                                <p class="text-xs text-gray-500 mt-1">
                                    Caracteres: {{ registerMessage.length }}
                                </p>
                            </div>

                            <div class="flex justify-end">
                                <button (click)="saveRegisterMessage()"
                                    [disabled]="registerMessageSaving || !registerMessage"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
                                    <i class="fas mr-2" [class.fa-spinner]="registerMessageSaving"
                                        [class.fa-spin]="registerMessageSaving"
                                        [class.fa-save]="!registerMessageSaving"></i>
                                    {{ registerMessageSaving ? 'Guardando...' : 'Guardar Mensaje' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Carrusel Tab: the banners of the Flutter app's Home, in their own component (DK-53) -->
                <div *ngIf="activeTab === 'carrusel'">
                    <app-carousel-config></app-carousel-config>
                </div>

                <!-- Modal Home App Tab -->
                <div *ngIf="activeTab === 'homeModal'">
                    <h2 class="text-xl font-semibold text-gray-900 mb-6">Configuración del Modal Home App</h2>

                    <!-- Loading State -->
                    <div *ngIf="homeModalLoading" class="text-center py-12">
                        <i class="fas fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
                        <p class="text-gray-600">Cargando configuración...</p>
                    </div>

                    <!-- Modal Home Global Status -->
                    <div *ngIf="!homeModalLoading" class="bg-gray-50 rounded-lg border border-gray-200 p-6 mb-6">
                        <div class="flex items-center justify-between">
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-2">
                                    <i class="fas fa-power-off text-blue-600 mr-2"></i>
                                    Estado del Modal Home
                                </h3>
                                <p class="text-sm text-gray-600">
                                    Controla si el modal se muestra cuando un usuario se loguea en la aplicación móvil
                                </p>
                            </div>
                            <div class="ml-6">
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" [checked]="homeModalEnabled"
                                        (change)="onHomeModalToggleChange($event)"
                                        [disabled]="homeModalToggleLoading || !_auth.hasPermission('config.app_movil.config')"
                                        class="sr-only peer" />
                                    <div
                                        class="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-blue-600">
                                    </div>
                                    <span class="ml-3 text-sm font-medium" [class.text-green-600]="homeModalEnabled"
                                        [class.text-gray-500]="!homeModalEnabled">
                                        {{ homeModalEnabled ? 'Activado' : 'Desactivado' }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Modal Home Image -->
                    <div *ngIf="!homeModalLoading" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-1">
                            <i class="fas fa-image text-blue-600 mr-2"></i>
                            Imagen del modal
                        </h3>
                        <p class="text-sm text-gray-600 mb-4">
                            La app muestra esta imagen a pantalla completa, una vez por sesión. Elige el archivo, revisa la
                            vista previa y confirma al final de la página.
                        </p>

                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <!-- File picker -->
                            <div class="lg:col-span-2">
                                <label for="homeModalImageInput"
                                    class="flex flex-col items-center justify-center w-full px-6 py-8 border-2 border-dashed rounded-lg transition-colors"
                                    [ngClass]="canEditHomeModal && !homeModalContentSaving ? 'border-gray-300 hover:border-blue-400 cursor-pointer' : 'border-gray-200 bg-gray-50 cursor-not-allowed'">
                                    <i class="fas fa-upload text-3xl text-gray-400 mb-3"></i>
                                    <span class="text-sm font-medium text-gray-700">Elegir imagen</span>
                                    <span class="text-xs text-gray-500 mt-1">PNG, JPG o WebP · 900 × 1600 px (9:16) · máximo 2 MB</span>
                                    <input id="homeModalImageInput" type="file" class="sr-only" [accept]="homeModalImageAccept"
                                        [disabled]="!canEditHomeModal || homeModalContentSaving"
                                        (change)="onHomeModalFileSelected($event)" />
                                </label>

                                <!-- Selected file -->
                                <div *ngIf="homeModalImageChecking" class="mt-3 text-sm text-gray-600">
                                    <i class="fas fa-spinner fa-spin mr-2"></i>Revisando la imagen...
                                </div>
                                <div *ngIf="homeModalSelectedImage && !homeModalImageChecking"
                                    class="mt-3 flex items-start justify-between rounded-lg border px-4 py-3"
                                    [ngClass]="homeModalSelectedImageError ? 'border-red-200 bg-red-50' : 'border-green-200 bg-green-50'">
                                    <div class="min-w-0">
                                        <p class="text-sm font-medium text-gray-900 truncate">{{ homeModalSelectedImage.name }}</p>
                                        <p class="text-xs text-gray-600 mt-0.5">
                                            <span *ngIf="homeModalSelectedImage.width !== null">{{ homeModalSelectedImage.width }} × {{ homeModalSelectedImage.height }} px · </span>{{ homeModalSelectedImage.sizeKb }} KB · {{ homeModalSelectedImage.format }}
                                        </p>
                                        <p *ngIf="homeModalSelectedImageError" class="text-xs text-red-700 mt-1">
                                            <i class="fas fa-exclamation-circle mr-1"></i>{{ homeModalSelectedImageError }}
                                        </p>
                                    </div>
                                    <div class="ml-4 flex items-center space-x-3 flex-shrink-0">
                                        <span *ngIf="!homeModalSelectedImageError"
                                            class="bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded">
                                            <i class="fas fa-check mr-1"></i>Lista para publicar
                                        </span>
                                        <button type="button" (click)="clearHomeModalSelectedFile()" [disabled]="homeModalContentSaving"
                                            class="text-gray-400 hover:text-gray-600 focus:outline-none disabled:opacity-50"
                                            title="Quitar archivo">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Image live in the app. Without an image the BFF serves the modal disabled, whatever the switch says. -->
                            <div class="rounded-lg border p-4"
                                [ngClass]="homeModalEnabled && !homeModalImageUrl ? 'bg-amber-50 border-amber-200' : 'bg-gray-50 border-gray-200'">
                                <h4 class="text-sm font-semibold text-gray-900 mb-3">
                                    <i class="fas fa-mobile-alt text-gray-500 mr-2"></i>
                                    Imagen vigente en la app
                                </h4>
                                <div *ngIf="homeModalImageUrl; else noCurrentImage" class="flex items-start space-x-4">
                                    <img [src]="homeModalImageUrl" alt="Imagen vigente del modal home"
                                        class="home-modal-thumb flex-shrink-0 rounded-lg border border-gray-200 bg-white object-contain" />
                                    <p *ngIf="homeModalImageUpdatedAt" class="text-xs text-gray-600">
                                        Actualizada {{ homeModalImageUpdatedAt | date:'dd-MMM-yyyy HH:mm':undefined:'es' }}
                                        <ng-container *ngIf="homeModalImageUpdatedBy"> por {{ homeModalImageUpdatedBy }}</ng-container>
                                    </p>
                                </div>
                                <ng-template #noCurrentImage>
                                    <p *ngIf="homeModalEnabled; else noCurrentImageIdle" class="text-sm text-amber-800">
                                        <i class="fas fa-exclamation-triangle mr-1"></i>
                                        Sin imagen cargada: el estado está activado, pero la app no muestra el modal hasta que
                                        subas una imagen y confirmes.
                                    </p>
                                    <ng-template #noCurrentImageIdle>
                                        <p class="text-sm text-gray-600">
                                            Sin imagen cargada: la app no mostrará el modal aunque actives el estado. Sube una
                                            imagen y confirma para publicarlo.
                                        </p>
                                    </ng-template>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <!-- Tap action -->
                    <div *ngIf="!homeModalLoading" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-1">
                            <i class="fas fa-link text-blue-600 mr-2"></i>
                            Acción al tocar la imagen
                        </h3>
                        <p class="text-sm text-gray-600 mb-4">Qué hace la app cuando el cliente toca la imagen del modal</p>

                        <div class="space-y-3">
                            <label class="flex items-start cursor-pointer">
                                <input type="radio" name="homeModalActionType" value="" [(ngModel)]="homeModalActionType"
                                    [disabled]="!canEditHomeModal || homeModalContentSaving"
                                    class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                                <span class="ml-3 text-sm text-gray-900">Sin acción (solo informativa)</span>
                            </label>

                            <label class="flex items-start cursor-pointer">
                                <input type="radio" name="homeModalActionType" value="internal" [(ngModel)]="homeModalActionType"
                                    [disabled]="!canEditHomeModal || homeModalContentSaving"
                                    class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                                <span class="ml-3 text-sm text-gray-900">Abrir una pantalla de la app</span>
                            </label>
                            <div *ngIf="homeModalActionType === 'internal'" class="ml-7">
                                <select [(ngModel)]="homeModalInternalRoute" [disabled]="!canEditHomeModal || homeModalContentSaving"
                                    class="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                                    <option value="" disabled>Elige una pantalla</option>
                                    <option *ngFor="let route of homeModalInternalRoutes" [value]="route.value">{{ route.label }}</option>
                                </select>
                            </div>

                            <label class="flex items-start cursor-pointer">
                                <input type="radio" name="homeModalActionType" value="external" [(ngModel)]="homeModalActionType"
                                    [disabled]="!canEditHomeModal || homeModalContentSaving"
                                    class="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                                <span class="ml-3 text-sm text-gray-900">Abrir un enlace externo</span>
                            </label>
                            <div *ngIf="homeModalActionType === 'external'" class="ml-7">
                                <input type="url" [(ngModel)]="homeModalExternalUrl" placeholder="https://..."
                                    [disabled]="!canEditHomeModal || homeModalContentSaving"
                                    class="w-full max-w-md px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                            </div>

                            <p *ngIf="homeModalActionError" class="text-xs text-red-700 ml-7">
                                <i class="fas fa-exclamation-circle mr-1"></i>{{ homeModalActionError }}
                            </p>
                        </div>
                    </div>

                    <!-- Preview -->
                    <div *ngIf="!homeModalLoading" class="bg-white rounded-lg border border-gray-200 p-6">
                        <h3 class="text-lg font-semibold text-gray-900 mb-4">
                            <i class="fas fa-eye text-blue-600 mr-2"></i>
                            Así la verá el cliente
                        </h3>

                        <div class="flex flex-col md:flex-row md:items-start md:space-x-8">
                            <!-- Phone frame -->
                            <div class="app-phone flex-shrink-0 mx-auto md:mx-0">
                                <div class="app-phone__home">
                                    <div class="h-5 w-24 bg-gray-200 rounded"></div>
                                    <div class="h-24 bg-gray-200 rounded-xl"></div>
                                    <div class="h-4 w-32 bg-gray-200 rounded"></div>
                                    <div class="h-16 bg-gray-200 rounded-xl"></div>
                                    <div class="h-16 bg-gray-200 rounded-xl"></div>
                                    <div class="h-4 w-20 bg-gray-200 rounded"></div>
                                    <div class="h-16 bg-gray-200 rounded-xl"></div>
                                </div>
                                <div class="app-phone__overlay">
                                    <div class="app-phone__creative">
                                        <img *ngIf="homeModalPreviewImage; else noPreviewImage" [src]="homeModalPreviewImage"
                                            alt="Vista previa del modal home" />
                                        <ng-template #noPreviewImage>
                                            <div class="app-phone__placeholder">
                                                <i class="fas fa-image text-2xl mb-2"></i>
                                                <span>Sin imagen</span>
                                            </div>
                                        </ng-template>
                                        <span class="app-phone__close"><i class="fas fa-times"></i></span>
                                    </div>
                                </div>
                            </div>

                            <!-- Hints and actions -->
                            <div class="mt-6 md:mt-0 flex-1 space-y-4">
                                <div class="bg-blue-50 border-l-4 border-blue-400 p-3">
                                    <p class="text-sm text-blue-700 font-medium">
                                        <i class="fas fa-hand-pointer mr-2"></i>{{ homeModalTapHint }}
                                    </p>
                                </div>
                                <ul class="text-sm text-gray-600 space-y-2">
                                    <li class="flex items-start">
                                        <i class="fas fa-clock text-gray-400 w-4 mt-0.5 mr-2"></i>Se ve en la app en hasta 5 minutos
                                    </li>
                                    <li class="flex items-start">
                                        <i class="fas fa-mobile-alt text-gray-400 w-4 mt-0.5 mr-2"></i>Una vez por sesión: al entrar o al abrir la app en frío
                                    </li>
                                    <li class="flex items-start">
                                        <i class="fas fa-power-off text-gray-400 w-4 mt-0.5 mr-2"></i>Publicar la imagen no enciende el modal: el switch de arriba manda
                                    </li>
                                </ul>

                                <div class="flex justify-end space-x-3 pt-2">
                                    <button type="button" (click)="resetHomeModalDraft()"
                                        [disabled]="homeModalContentSaving || !homeModalHasChanges"
                                        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:opacity-50 disabled:cursor-not-allowed">
                                        Cancelar
                                    </button>
                                    <button type="button" (click)="publishHomeModalContent()" [disabled]="!canPublishHomeModal"
                                        class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
                                        <i class="fas mr-2" [class.fa-spinner]="homeModalContentSaving"
                                            [class.fa-spin]="homeModalContentSaving"
                                            [class.fa-check]="!homeModalContentSaving"></i>
                                        {{ homeModalContentSaving ? 'Publicando...' : 'Confirmar y publicar' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Add Service Modal -->
                <div *ngIf="showAddServiceModal"
                    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
                    (click)="closeAddServiceModal()">
                    <div class="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-lg bg-white"
                        (click)="$event.stopPropagation()">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-lg font-semibold text-gray-900">Agregar Nuevo Servicio</h3>
                            <button (click)="closeAddServiceModal()"
                                class="text-gray-400 hover:text-gray-600 focus:outline-none">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <form [formGroup]="addServiceForm" (ngSubmit)="submitAddService()">
                            <div class="space-y-4">
                                <!-- Code -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Código <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="code"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: PAYMENT_SERVICE" />
                                </div>

                                <!-- Name -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Nombre <span class="text-red-500">*</span>
                                    </label>
                                    <input type="text" formControlName="name"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="ej: Servicio de Pagos" />
                                </div>

                                <!-- Description -->
                                <div>
                                    <label class="block text-sm font-medium text-gray-700 mb-1">
                                        Descripción
                                    </label>
                                    <textarea formControlName="description" rows="3"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Descripción del servicio"></textarea>
                                </div>

                                <div class="grid grid-cols-2 gap-4">
                                    <!-- Order -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Orden <span class="text-red-500">*</span>
                                        </label>
                                        <input type="number" formControlName="order" min="1"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                    </div>

                                    <!-- Parent Service -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Servicio Padre
                                        </label>
                                        <select formControlName="parent"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                                            <option value="">Ninguno</option>
                                            <option *ngFor="let service of rootServices" [value]="service.code">
                                                {{ service.name || service.code }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-end space-x-3 mt-6">
                                <button type="button" (click)="closeAddServiceModal()"
                                    class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400">
                                    Cancelar
                                </button>
                                <button type="submit" [disabled]="addServiceLoading || !addServiceForm.valid"
                                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                                    <i class="fas" [class.fa-spinner]="addServiceLoading"
                                        [class.fa-spin]="addServiceLoading" [class.fa-plus]="!addServiceLoading"
                                        class="mr-2"></i>
                                    {{ addServiceLoading ? 'Agregando...' : 'Agregar Servicio' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
